import React, { useEffect, useReducer } from 'react';

// REDUX
import { getFixesState, getNumberOfReels, setFixesState } from '@Managers/Redux/AppState/AppState';
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';
import { IFixData, IFixSelectorExtended } from '../../Fixes.types';

// STYLES
import { getAuthenticateData } from '@Managers/Redux/HttpState';
import arrayCopy from '@Tools/ArrayCopy';
import styles from '../../Fixes.scss';
import ReelSets from './ReelSets/ReelSets';

const FixesExtendedSelector: React.FC<{}> = ({}) => {
    const [state, setState] = useReducer((state: IFixSelectorExtended, newState: {}) => ({ ...state, ...newState }), {
        fixReelsData: [],
        fixString: ''
    });

    const dispatch = useAppDispatch();
    const fixesState = useAppSelector(getFixesState);
    const numberOfReels = useAppSelector(getNumberOfReels);
    const authenticateData = useAppSelector(getAuthenticateData);

    function setFixIndex(evt: any, key: number) {
        let fixValue = evt.currentTarget.value.length === 0 ? 0 : evt.currentTarget.value;

        if (Number(fixValue) || fixValue === 0) {
            fixValue = Number(fixValue);

            const maxValue = state.fixReelsData[key].length;

            if (fixValue > maxValue) fixValue = maxValue;

            dispatch(setFixesState({ fixReelPosition: { ...fixesState.fixReelPosition, [key]: fixValue } }));
        }
    }

    function AddNew() {
        const _array = arrayCopy(fixesState.fixArray);
        const _combinatons = arrayCopy(fixesState.fixCombinations);
        const fixValues = Object.values(fixesState.fixReelPosition);
        const fixString = fixValues.toString();
        _array.push(fixString);
        _combinatons.push(fixString);
        dispatch(setFixesState({ fixArray: _array, fixCombinations: _combinatons }));
    }

    useEffect(() => {
        if (Object.keys(fixesState.fixReelPosition).length === 0) {
            const fixData: IFixData = {};
            for (var i = 0; i < numberOfReels; i++) {
                fixData[i] = 0;
            }
            dispatch(setFixesState({ fixReelPosition: fixData }));
        }
    }, []);

    useEffect(() => {
        if (authenticateData?.outcome.reelsets) setState({ fixReelsData: authenticateData?.outcome.reelsets[0].set });
    }, [authenticateData]);

    useEffect(() => {
        if (fixesState.fixReelPosition) setState({ fixData: fixesState.fixReelPosition });
    }, [fixesState.fixReelPosition]);

    return (
        <>
            <div className={styles.fix_group}>
                <div className={styles.fix_group_header}>Fix List (Extended)</div>
                <div className={styles.fix_group_options}>
                    <ReelSets fixData={fixesState.fixReelPosition} fixArrays={state.fixReelsData} />

                    <div className={styles.fix_group_options}>
                        {Object.keys(fixesState.fixReelPosition).map((key, i) => {
                            const fixKey = Number(key);
                            return (
                                <div key={i} className={styles.fix_group_option_item}>
                                    <input key={i} type="text" onInput={(evt) => setFixIndex(evt, fixKey)} value={fixesState.fixReelPosition[fixKey]} />
                                </div>
                            );
                        })}
                        <button className={styles.add_new_fix_btn} onClick={(evt) => AddNew()}>
                            +
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FixesExtendedSelector;
